import { Login } from "./login";
import { Members } from "./members";
import { Consulting } from "./consulting";
import { PasswordSetting } from "./passwordSetting";
import { DetailConsulting } from "./detailConsulting";
import { Setting } from "./settings";

const Admin = {
  Login,
  Members,
  Consulting,
  DetailConsulting,
  PasswordSetting,
  Setting,
};

export default Admin;
